.active {
    z-index: 1;
}
